import { Injectable } from '@angular/core';
import { NgxsDataRepository } from '@angular-ru/ngxs/repositories';
import { Computed, StateRepository } from '@angular-ru/ngxs/decorators';
import { State } from '@ngxs/store';
import { ReachEvent, ReachEventService } from '@portals/api';

import { finalize, mergeMap, tap } from 'rxjs/operators';

interface StateModel {
	isLoading: boolean;
	data: Array<ReachEvent>;
	selected: ReachEvent;
}

@StateRepository()
@State<StateModel>({
	name: 'events',
})
@Injectable()
export class ReachEventsState extends NgxsDataRepository<StateModel> {
	@Computed()
	get isLoading() {
		return this.snapshot.isLoading;
	}

	@Computed()
	get hasData() {
		return !!this.snapshot.data;
	}

	@Computed()
	get data() {
		return this.snapshot.data;
	}

	@Computed()
	get item() {
		return this.snapshot.selected;
	}

	constructor(private reachEventService: ReachEventService) {
		super();
	}

	load() {
		this.patchState({ isLoading: true });

		return this.reachEventService.find({ params: { sort: 'createdAt:desc' } }).pipe(
			tap(({ data }) => {
				this.patchState({ data });
			}),
			finalize(() => {
				this.patchState({ isLoading: false });
			})
		);
	}

	findOne(id: number) {
		return this.reachEventService.findOneById(id);
	}

	findOneByUUID(uuid: string) {
		return this.reachEventService.findOneByUUID(uuid, {
			skipInterceptor: true,
		});
	}

	create(payload: FormData) {
		this.patchState({ isLoading: true });

		return this.reachEventService.create(payload).pipe(mergeMap(() => this.load()));
	}

	update(id: number, formData: FormData) {
		this.patchState({ isLoading: true });

		return this.reachEventService.update(id, formData).pipe(mergeMap(() => this.load()));
	}
}
